import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import ImageLayerData from './image-layer-data';
import PatternLayerData from './pattern-layer-data';
import ParallaxLayerData from './parallax-layer-data';
import ScrollingLayerData from './scrolling-layer-data';
import AnimationLayerData from './animation-layer-data';
import '../common/dialog.css';

/** @LayerDialog
 * A component for exposing properties on a layer
 * for editing.
 */
export default class LayerDialog extends Component {

  renderLayer() {
    switch(this.props.layer.type) {
      case 'image':
        return <ImageLayerData {...this.props}/>
      case 'pattern':
        return <PatternLayerData {...this.props}/>
      case 'scroll':
        return <ScrollingLayerData {...this.props}/>
      case 'parallax':
        return <ParallaxLayerData {...this.props}/>
      case 'animation':
        return <AnimationLayerData {...this.props}/>
      default:
        return null
    }
  }
  /** @function render
    * Renders the component.
    */
  render() {
    if(!this.props.show) return null;
    return (
      <div>
        <div className="dialog-mask"></div>
        <div className="dialog-wrapper">
          <div className="dialog">
            <div className="dialog-close">
              <button onClick={this.props.onExit}><FontAwesome name="times"/></button>
            </div>
            {this.renderLayer()}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/stage-editor/layer-dialog.js